import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import reducer from "./reducers/reducer";
// import api from "./middleware/api";

const configureStoreFunc = function () {
  return configureStore({
    middleware: [...getDefaultMiddleware()],
    reducer,
    devTools: true,
  });
};

export default configureStoreFunc;
